import React, { useState, useEffect, use } from "react";
import PopupGallery from "./PopupGallery";

export default function TextareaList({
  config,
  targetValue = [],
  value = [],
  dataObject = {},
  onChange = () => {},
  selectedList = [],
  isDisable= false,
  popupGalleryProps = {},
  setListData=()=>{}
}) {
 
//console.log("popupGalleryProps", popupGalleryProps)
  const { values: defaultValues = [], conditional } = config;
  const [items, setItems] = useState([]);
const [field, operator, variable] = conditional
        .split(" ")
        .map((s) => s.trim());

const [formData, setFormData] = useState({
  data: popupGalleryProps?.data || {},
  status: "IDLE",
  field:{
    name:"driveVideoUrl"
  }

});

//console.log("formDataformDataformDataformData",formData)
const userDeep = popupGalleryProps?.userDeep || {}
      //   props.setFormData({
      //   data: { ...props.data, [props.field.name]: files[index] },
      //   status: "IDLE",
      // })


  // Build + filter items whenever dependencies change
  useEffect(() => {
    let merged;

    if (value && value.length > 0) {
      // If parent provided value, take it
      merged = value;
    } else {
      // Otherwise merge defaultValues + targetValue
      const map = new Map(defaultValues.map((v) => [v.name, v]));
      targetValue.forEach((tv) => {
        if (!map.has(tv.name)) {
          map.set(tv.name, tv);
        }
      });
      merged = Array.from(map.values());
    }

  

    setItems(merged);
  }, []);
  useEffect(() => {
    let merged = [];

   
    if (value && value.length > 0) {
      // If parent provided value, take it
      merged = value;
  
    } else {
      // Otherwise merge defaultValues + targetValue
      const map = new Map(defaultValues.map((v) => [v.name, v]));
      targetValue.forEach((tv) => {
        if (!map.has(tv.name)) {
          map.set(tv.name, tv);
        }
      });
      merged = Array.from(map.values());
    }

    // Apply conditional filter
    if (conditional) {
      

      const conditionValues = Array.isArray(dataObject[variable])
        ? dataObject[variable]
        : [dataObject[variable]];


      merged = merged.filter((item) => {
        if (operator === "==") {
          return conditionValues.includes(item[field]);
        }
        if (operator === "!=") {
          return !conditionValues.includes(item[field]);
        }
        return true;
      });
      let allMergedNames = conditionValues?.filter((cond)=>{

        for(let item of merged){
          if(item.name!=cond){
            return true
          }
          else{
            return false
          }
        }
      })||[]
 


        const map = new Map(defaultValues.map((v) => [v.name, v]));
      targetValue.forEach((tv) => {
        if (!map.has(tv.name)) {
          map.set(tv.name, tv);
        }
      });
      let dummydata = Array.from(map.values());
      let datttaa = merged
          
      allMergedNames.filter(cond=>{

        dummydata.filter((dum)=>{
         
        })
          let found = dummydata.find(k=>k.name==cond)
          let checkstatus = merged.find(k=>k.name==cond)
          if(found && !checkstatus){
            merged.push(found)
            // datttaa.push(found)
          
          }
      })
   
      
    }

    setItems(merged);
  }, [dataObject[variable], defaultValues?.length]);

  // Notify parent whenever items change
  useEffect(() => {
    if (onChange) {
      onChange(items);
    }
  }, [items]);

  const handleChange = (name, val) => {
    const updated = items.map((item) =>
      item.name === name ? { ...item, value: val } : item
    );
    setItems(updated);
  };

const handleVideoSelect = (name, file) => {
  const updat = items.map((item) =>

    item.name === name
      ? { ...item, videoUrl: file.src } // store separately
      : item
  );
  setItems(updat);
};


useEffect(() => {

  if (formData?.data?.driveVideoUrl) {
setListData("driveVideoUrl", formData?.data?.driveVideoUrl);
  }

}, [formData?.data?.driveVideoUrl]);


   return (
    <div style={{ width: "100%", padding: "10px" }}>
      {items.map((item, i) => {
        const isYouTube =
          item.name?.toLowerCase && item.name.toLowerCase() === "youtube";
        return (
          <div key={i} style={{ marginBottom: "20px" }}>
            <p style={{ marginBottom: "6px", textTransform: "capitalize" }}>
              {item.name}
            </p>

            {/* --- Moved ABOVE the textarea & placed on ONE LINE --- */}
           {isYouTube && popupGalleryProps?.userDeep?.id && (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start", // Changed this to align from the top
      gap: 10,
      marginBottom: 8,
      flexDirection: "column", // Added this to stack items vertically
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <PopupGallery 
        allowVideo={true} 
        setFormData={setFormData} 
        data={formData.data} 
        userDeep={userDeep} 
        field={{name:"driveVideoUrl"}} 
      /> 
      <span 
        style={{ 
          color: "#fff", 
       
          padding: "6px 10px", 
          borderRadius: 4, 
          whiteSpace: "nowrap", 
          lineHeight: 1.2, 
        }}
      >
        You have selected YouTube — upload a video.
      </span>
    </div>

    {/* Input box below PopupGallery */}
    <input
      type="text"
      value={formData?.data?.driveVideoUrl || ""}
      placeholder="Video URL"
      style={{
        width: "100%",
        padding: "8px",
        fontSize: "14px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        marginTop: "8px",
      }}
      readOnly
    />

    {/* Preview player */}
    {formData?.data?.driveVideoUrl && (
                  <video
                    src={formData.data.driveVideoUrl}
                    controls
                    style={{
                      marginTop: "10px",
                      maxWidth: "100%",
                      borderRadius: "6px",
                    }}
                  />
    )}
  </div>
)}

            <textarea
              value={item.value || ""}
              onChange={(e) => handleChange(item.name, e.target.value)}
              placeholder={config.placeholder || ""}
              style={{
                width: "100%",
                minHeight: "150px",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                resize: "vertical",
                background: "white",
              }}
              disabled={isDisable}
            />
          </div>
        );
      })}
    </div>
  );
}
